export const lineLineCollision = (x1, y1, x2, y2, x3, y3, x4, y4) => {
  let collision = false;
  const dA =
    ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) /
    ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
  const dB =
    ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) /
    ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
  if (dA >= 0 && dA <= 1 && dB >= 0 && dB <= 1) {
    collision = true;
  }
  return collision;
};

export const pointPolyCollision = (coordinates, x, y) => {
  let collision = false;
  for (let i = 0; i < coordinates.length; i++) {
    const j = i + 1 === coordinates.length ? 0 : i + 1;
    const coordI = coordinates[i];
    const coordJ = coordinates[j];
    if (
      ((coordI.y >= y && coordJ.y < y) || (coordI.y < y && coordJ.y >= y)) &&
      x < ((coordJ.x - coordI.x) * (y - coordI.y)) / (coordJ.y - coordI.y) + coordI.x
    ) {
      collision = !collision;
    }
  }
  return collision;
};

export const linePolyCollision = (coordinates, x1, y1, x2, y2) => {
  let collision = false;
  for (let i = 0; i < coordinates.length; i++) {
    const j = i + 1 === coordinates.length ? 0 : i + 1;
    const x3 = coordinates[i].x;
    const y3 = coordinates[i].y;
    const x4 = coordinates[j].x;
    const y4 = coordinates[j].y;
    if (lineLineCollision(x1, y1, x2, y2, x3, y3, x4, y4)) {
      collision = true;
      break;
    }
  }
  return collision;
};

export const polyPolyCollision = (coordinatesA, coordinatesB) => {
  let collision = false;
  for (let i = 0; i < coordinatesB.length; i++) {
    const x = coordinatesB[i].x;
    const y = coordinatesB[i].y;
    if (pointPolyCollision(coordinatesA, x, y)) {
      collision = true;
      break;
    }
  }
  for (let i = 0; i < coordinatesA.length; i++) {
    const j = i + 1 === coordinatesA.length ? 0 : i + 1;
    const coordI = coordinatesA[i];
    const coordJ = coordinatesA[j];
    if (linePolyCollision(coordinatesB, coordI.x, coordI.y, coordJ.x, coordJ.y)) {
      collision = true;
      break;
    }
  }
  return collision;
};

export const checkAnyPolyCollision = (polys, coordinates) => {
  for (const poly of polys) {
    if (polyPolyCollision(poly, coordinates)) {
      return true;
    }
  }
};

export const checkPolyInPoly = (coordinatesA, coordinatesB) => {
  return coordinatesB.every((coord) => pointPolyCollision(coordinatesA, coord.x, coord.y));
};

export const checkAnyPolyInPoly = (polys, coordinates) => {
  for (const poly of polys) {
    if (checkPolyInPoly(poly, coordinates)) {
      return true;
    }
  }
};

export const getCoordinatesFromRect = (rect) => {
  return [
    { x: rect.left, y: rect.top },
    { x: rect.left + rect.width, y: rect.top },
    { x: rect.left + rect.width, y: rect.top + rect.height },
    { x: rect.left, y: rect.top + rect.height },
  ];
};

export const rotateCoordinate = (cx, cy, x, y, angle) => {
  const radians = angle * (Math.PI / 180);
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const nx = cos * (x - cx) - sin * (y - cy) + cx;
  const ny = cos * (y - cy) + sin * (x - cx) + cy;
  return [Math.round(nx), Math.round(ny)];
};

export const getCenteredCoordinates = (cx, cy, width, height, rotation) => {
  let coordinates = [
    { x: cx - width / 2, y: cy - height / 2 },
    { x: cx + width / 2, y: cy - height / 2 },
    { x: cx + width / 2, y: cy + height / 2 },
    { x: cx - width / 2, y: cy + height / 2 },
  ];

  if (rotation >= 0) {
    coordinates = coordinates.map((e) => {
      const rotated = rotateCoordinate(cx, cy, e.x, e.y, rotation);
      return {
        x: rotated[0],
        y: rotated[1],
      };
    });
  }

  return coordinates;
};

export const getBoundingRectFromCoords = (coordinates) => {
  const xMin = Math.min(...coordinates.map((e) => e.x));
  const xMax = Math.max(...coordinates.map((e) => e.x));
  const yMin = Math.min(...coordinates.map((e) => e.y));
  const yMax = Math.max(...coordinates.map((e) => e.y));
  return {
    top: yMin,
    left: xMin,
    width: xMax - xMin,
    height: yMax - yMin,
    coords: [
      { x: xMin, y: yMin },
      { x: xMax, y: yMin },
      { x: xMax, y: yMax },
      { x: xMin, y: yMax },
    ],
  };
};
